import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from 'components/Icon';

import css from './FilterToggleButton.module.scss';

class FilterToggleButton extends React.PureComponent {
    static propTypes = {
        activeFilters: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        open: PropTypes.bool.isRequired,
    }

    render() {
        const {
            activeFilters,
            label,
            onClick,
            open,
        } = this.props;

        return (
            <button
                className={cn(css.button, 'filter', {
                    [css.open]: open,
                })}
                onClick={onClick}
            >
                <div>
                    <span>{label}</span>
                    <span className={css.filters}>{activeFilters}</span>
                    <Icon className={css.arrow} icon="arrow-down" />
                </div>
            </button>
        );
    }
}

export default FilterToggleButton;



// WEBPACK FOOTER //
// ./src/components/FilterToggleButton/FilterToggleButton.jsx